import { userHasLevel } from "../../../engine/AuthRoute";
import { isInstitutionGrouped, roles } from "../../../utils/constants";
import { Button, Tag } from "antd";
import {
  mainTypesPrestation,
  typesPrestation,
} from "../../../utils/typesPrestation";
import { renderAdress } from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { GrPowerReset } from "react-icons/gr";
import React from "react";

/**
 * Same visibility as Institution detail "ID Abacus" (admin + permanence).
 * Uses `useContext` via `userHasLevel` — call only during render, never inside callbacks/async handlers.
 */
export function canViewInstitutionAbacusId() {
  return userHasLevel({
    only: {
      [roles.admin]: "r",
      [roles.permanance]: "r",
    },
  });
}

export const columnsInstitutionsList = [
  {
    title: "Nom",
    dataIndex: "name",
    key: "name",
    render: (n, record) => n,
    width: "15%",
    sorter: (a, b) => {
      return a.name.localeCompare(b.name);
    },
  },
  {
    title: "ID Abacus",
    dataIndex: "abacusId",
    key: "abacusId",
    render: v => (v != null && v !== "" ? v : "-"),
    width: "10%",
    sorter: (a, b) => {
      return String(a?.abacusId ?? "").localeCompare(
        String(b?.abacusId ?? ""),
        undefined,
        { numeric: true },
      );
    },
  },
  {
    title: "Mandant global",
    dataIndex: "principal",
    key: "principal",
    render: (n, record) => n?.name || "-",
    width: "15%",
    sorter: (a, b) => {
      return a?.principal?.name?.localeCompare(b?.principal?.name);
    },
  },
  {
    title: "Domaine",
    dataIndex: "mainType",
    width: "15%",
    key: "mainType",
    sorter: (a, b) => {
      return a?.mainType?.localeCompare(b?.mainType);
    },
  },
  {
    title: "Adresse par défaut",
    dataIndex: "defaultAddress",
    width: "15%",
    key: "defaultAddress",
    render: (a, i) => renderAdress(a, false, i),
    // sorter: (a, b) => {
    //   return a?.mainType?.localeCompare(b?.mainType);
    // },
  },
  {
    title: "Restriction par demandeur",
    dataIndex: "restrictionPerApplicant",
    width: "15%",
    key: "restrictionPerApplicant",
    render: (a, i) => {
      if (i.restrictionPerApplicant) {
        return <Tag color="green">Oui</Tag>;
      } else {
        return <Tag color="red">Non</Tag>;
      }
    },
    sorter: (a, b) => {
      // Sorter by boolean groupedBilling
      return a.restrictionPerApplicant - b.restrictionPerApplicant;
    },
  },

  {
    title: "Restreindre les commandes",
    dataIndex: "readOnlyPrestation",
    width: "15%",
    key: "readOnlyPrestation",
    render: (a, i) => {
      if (i.readOnlyPrestation === true || i.readOnlyPrestation === undefined) {
        return <Tag color="green">Oui</Tag>;
      } else {
        return <Tag color="red">Non</Tag>;
      }
    },
    sorter: (a, b) => {
      const valA = a.readOnlyPrestation === false ? 0 : 1;
      const valB = b.readOnlyPrestation === false ? 0 : 1;
      return valA - valB;
    },
    // sorter: (a, b) => {
    //   return a?.mainType?.localeCompare(b?.mainType);
    // },
  },

  {
    title: "Facturation groupée",
    dataIndex: "groupedBilling",
    width: "15%",
    key: "groupedBilling",
    render: (groupedBilling, record) => {
      if (isInstitutionGrouped(record)) {
        return <Tag color="blue">Oui</Tag>;
      } else {
        return <Tag color="grey">Non</Tag>;
      }
    },
    sorter: (a, b) => {
      // Sorter by boolean groupedBilling
      return isInstitutionGrouped(a) - isInstitutionGrouped(b);
    },
  },
];

export const inputsInstitutionsList = setSearch => [
  {
    parentLabel: null,
    children: [
      {
        label: "Recherche",
        placeholder: "Nom, domaine, intervention, tags",
        name: "search",
        value: "",
        type: "input",
        capitalize: false,
        col: 6,
      },
      {
        label: "Filtre par mandant",
        name: "principal",
        type: "dynamic-select",
        allowClear: true,
        width: 300,
        endPoint: "principals",
        itemsCallBack: (principals, form) => {},
        itemCallback: item => {
          return {
            key: item._id,
            label: `${item.name}`,
            value: item._id,
          };
        },
        col: 6,
      },
      {
        label: "Filtre par type",
        name: "type",
        disabled: true,
        value: undefined,
        allowClear: true,
        type: "select",
        selectContent: typesPrestation,
        selectType: "group",
        col: 6,
      },
      {
        type: "component",
        col: 6,
        label: "",
        style: { textAlign: "left" },
        component: ({ disabled, refForm, form }) => (
          <Button
            style={{
              marginTop: "-7px",
              width: "100%",
              color: colorPrimary,
              fontWeight: "bold",
            }}
            icon={<GrPowerReset style={{ marginTop: "-3px" }} size={15} />}
            onClick={async () => {
              setSearch("");
              refForm?.resetFields(); // Reset the form fields using the ref
              form?.resetFields(); // Reset the form fields using the ref
              form?.resetLocalStorage();
            }}
            size="middle"
            type={"text"}
          >
            Réinitialiser
          </Button>
        ),
      },
    ],
  },
];
